import {venues} from "./volunteerExperienceData";
import React from "react";
import {Button} from "semantic-ui-react";
import moment from "moment";

export const TheatreSeason = ({season}) =>
    season.map(({venue, dates, link}) => {
        const isArray = Array.isArray(dates);

        const nPerformances = isArray ? dates.length : null
        let formatted = nPerformances === 1 && new Date(dates[0]).toLocaleDateString()
        let beforeEndOfSeason
            // `${new Date(dates[0]).toLocaleDateString()} - ${new Date(dates[dates.length - 1]).toLocaleDateString()}`

        if (!isArray) {
            formatted = dates
        }

        if (isArray) {
            const start = moment(dates[0])
            const end = moment(dates[dates.length - 1])
            if (start.isSame(end, 'date') && start.isSame(end, 'month') && start.isSame(end, 'year')) {
                formatted = `${end.format('D MMMM YYYY')}`;
            } else if (start.isSame(end, 'month') && start.isSame(end, 'year')) {
                formatted = `${start.date()} - ${end.date()} ${end.format('MMMM YYYY')}`;
            } else if (start.isSame(end, 'year')) {
                formatted = `${start.format('D MMMM')} - ${end.format('D MMMM YYYY')}`;
            } else {
                formatted = `${start.format('D MMMM YYYY')} - ${end.format('D MMMM YYYY')}`;
            }

            beforeEndOfSeason = moment().isBefore(end);
        }


        return <div key={venue} className='volunteer-experience-venues'>
            <h4 className="vertical-timeline-element-subtitle">{venues[venue]?.title}</h4>
            <h5 className="vertical-timeline-element-subtitle">{venues[venue]?.address}</h5>
            <h5 style={{color: 'grey'}} className="vertical-timeline-element-subtitle">{formatted} {nPerformances && <small>[{nPerformances} {nPerformances === 1 ? 'performance' : 'performances'}]</small>}</h5>
            { link && beforeEndOfSeason && <Button as='a' href={link} primary target='_blank' compact className={'button-style'}>Buy Tickets</Button> }
        </div>;
    })